export default __webpack_public_path__ + "images/08036913261cb37408cc5ab5622688c0-badge-andy-call.svg";